const BlockChainErrorsHandler=(TxError,defaultErrMsg)=>{
    let errDescription=TxError?.message?.message !== undefined 
    ?
    TxError?.message?.message?.includes("Declined") 
    ?
    TxError?.message?.message
    :
    TxError?.message?.errorMessage 
    : 
    TxError?.message?.includes("pre-condition failed") 
    ?
    TxError?.message?.split("pre-condition failed:")?.[1]?.split("\n")[0]
    :
    TxError?.message?.includes("[Error Code: 1006]") 
    ?
    TxError?.message?.split("[Error Code: 1006]")?.[1]
    :
    TxError?.message?.includes("[Error Code: 1008]")
    ?
    TxError?.message?.split("[Error Code: 1008]")?.[1]
    :
    TxError?.message?.includes("assertion failed")
    ?
    TxError?.message?.split("assertion failed:")?.[1]?.split("-->")?.[0]
    :
    TxError?.message?.errorMessage?.includes("pre-condition failed") 
    ?
    TxError?.message?.errorMessage?.split("pre-condition failed:")?.[1].split("\n")[0] 
    :
    TxError?.message?.errorMessage 
    ??
    TxError?.message
    ??
    TxError?.split("cadence runtime error:")[1]?.split("\n")[1]
    ??
    TxError?.split("[Error Code: 1006]")?.[1]
    ??
    defaultErrMsg;

    return errDescription;
}
export default BlockChainErrorsHandler;